import {BaseAnalyticsShowEvent} from "../../../infrastructure/models/analytics/base-analytics-show-event";

export class PromoAnalyticsShowEvent extends BaseAnalyticsShowEvent {
  constructor(params: PromoAnalyticsShowEvent) {
    super('promo');

    this.source = params.source;
    this.promoName = params.promoName;
  }

  get properties(): Object {
    const properties = super.properties;

    properties.source = this.source;
    properties.promoName = this.promoName;

    return properties;
  }
}